import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment'

/**
 * This class is the service used to send data to Google Analytics
 */
@Injectable()
export class GoogleAnalyticsService {

	/** A flag to determine if the google analytics service has been initialized */
	private _IsInitialized: boolean = false;

	/**
	 * Initialize the Google Analytics data for tracking through out the application
	 * */
	public Initialize(): void {
		let objHead: HTMLElement;
		let objUAScript, objGAScript: HTMLElement;

		if (environment.EnableGoogleAnalytics) {
			objHead = document.getElementsByTagName("head")[0];
			// Create the Javascript variable that will hold the GA UA tracking number.
			objUAScript = document.createElement("script");
			objUAScript.innerHTML = `var GA_MEASUREMENT_ID = '${environment.GoogleAnalyticsUAID}';`;
			objHead.insertBefore(objUAScript, objHead.firstChild);

			// Create the GA Javascript to enable tracking.
			objGAScript = document.createElement("script");
			objGAScript.innerHTML = "window.dataLayer = window.dataLayer || [];\n" +
				"function gtag() { dataLayer.push(arguments); }\n" +
				"gtag('js', new Date());\n" +
				"gtag('config', GA_MEASUREMENT_ID, { 'send_page_view': false });";
			objHead.insertBefore(objGAScript, objUAScript.nextSibling);

			this._IsInitialized = true;
		}
	}

	/**
	 * Posts a page view event to Google Analytics
	 * @param PageTitle The title of the page view being tracked
	 * @param PageUrl The URL of the page view being tracked
	 * @param UserId The Cosmos DB GUID of the logged in user to be used when tracking events with google analytics
	 */
	public TrackPageViewEvent(PageTitle: string, PageUrl: string, UserId: string): void {
		if (this._IsInitialized) {
			let pageEvent = `gtag('config', GA_MEASUREMENT_ID, {
				'page_title': '${PageTitle}',
				'page_path': '${PageUrl}'});`
			let userEvent = `gtag('config', GA_MEASUREMENT_ID, {'user_id': '${UserId}'});`

			// If the user identifier is null we don't want to send it to google analytics
			// The google analytics documentation will use a auto assigned device id in place of the user id
			// https://support.google.com/analytics/answer/9213390?hl=en&ref_topic=9833394
			let trackEvent = UserId == null ? pageEvent : pageEvent + "\n" + userEvent;
			eval(trackEvent);
		}
	}
}
